const $ = jQuery.noConflict();
import 'slick-carousel';

import lottieWeb from 'lottie-web';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),
	$domSliderPrev: $('.js-slider__arr-prev'),
	$domSliderNext: $('.js-slider__arr-next'),
	$domSliderTime: $('.js-slider-time'),
	$domSliderFull: $('.js-slider-full'),
	$domSliderFullPrev: $('.js-slider-full__arr-prev'),
	$domSliderFullNext: $('.js-slider-full__arr-next'),
	$domSliderSidePrev: $('.js-slider-side__arr-prev'),
	$domSliderSideNext: $('.js-slider-side__arr-next'),

	/** @description Initialize. */
	init: function() {

		this.initSliderMain();
		this.initSliderTime();
		this.initSliderFull();
		if(Sliders.$domSlider.length) {
			const numOfSlides = $('.slider-boxes__box').length;
			if(numOfSlides < 2) {
				$('.slider-box__wrap').addClass('hide-arrows');
			}
		}
		if (jQuery(window).width() > 767) {
			if(Sliders.$domSliderFull.length) {
				const numOfSlides = $('.slider-full__bottom-box').length;
				if(numOfSlides < 4) {
					$('.slider-full__upper-wrap').addClass('hide-arrows');
				}
			}
		}

		if (jQuery(window).width() < 767) {
			if(Sliders.$domSliderFull.length) {
				const numOfSlides = $('.slider-full__bottom-box').length;
				if(numOfSlides < 3) {
					$('.slider-full__upper-wrap').addClass('hide-arrows');
				} else {
					$('.slider-full__upper-wrap').removeClass('hide-arrows');
				}
			}
		}

		Sliders.$domSliderTime.on('afterChange', function(event, slick, currentSlide) {
			if ($(window).width() > 991) {
				if (slick.$slides.length === currentSlide + 2 + slick.options.slidesToScroll) {
					$('.js-slider-time').slick('slickPause');
				}
			}
			if (($(window).width() < 992) && ($(window).width() > 400)) {
				if (slick.$slides.length === currentSlide + 1 + slick.options.slidesToScroll) {
					$('.js-slider-time').slick('slickPause');
				}
			}
			if ($(window).width() < 401) {
				if (slick.$slides.length === currentSlide + slick.options.slidesToScroll) {
					$('.js-slider-time').slick('slickPause');
				}
			}
		});
		this.animationSetup();
		// side slider
		$('.js-slider-side-content').slick({
			slidesToShow: 1,
			arrows: true,
			asNavFor: '.js-slider-side-navigation',
			prevArrow: Sliders.$domSliderSidePrev,
			nextArrow: Sliders.$domSliderSideNext,
			autoplay: true,
			fade: true,
			infinite: true,
			dots: false
		});

		$('.js-slider-side-navigation').slick({
			slidesToShow: 8,
			asNavFor: '.js-slider-side-content',
			vertical: true,
			focusOnSelect: true,
			autoplay: true,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false
		});
	},

	animationSetup: function() {
		const animContainer = document.getElementById('slider-boxes-1');
		let slideFirst;
		let slideSecond;
		let slideThird;

		if (animContainer) {
			slideFirst = lottieWeb.loadAnimation({
				container: animContainer,
				renderer: 'svg',
				path: '../wp-content/themes/fws-allways-forwarding/src/assets/animations/Boat.json',
				loop: false,
				autoplay: false,
				rendererSettings: {
					progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
				},
			});
		}

		const animContainer2 = document.getElementById('slider-boxes-2');

		if (animContainer2) {
			slideSecond = lottieWeb.loadAnimation({
				container: animContainer2,
				renderer: 'svg',
				path: '../wp-content/themes/fws-allways-forwarding/src/assets/animations/Truck.json',
				loop: false,
				autoplay: false,
				rendererSettings: {
					progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
				},
			});
		}

		const animContainer3 = document.getElementById('slider-boxes-3');

		if (animContainer3) {
			slideThird = lottieWeb.loadAnimation({
				container: animContainer3,
				renderer: 'svg',
				path: '../wp-content/themes/fws-allways-forwarding/src/assets/animations/Airplane.json',
				loop: false,
				autoplay: false,
				rendererSettings: {
					progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
				},
			});
		}

		$(document).ready(function() {

			if(animContainer) {
				setTimeout(() => {
					//remove loader
					$('.js-slider-main').addClass('loader-removed');

					//play first animation when document loads
					slideFirst.play();
				}, 3000);
			}
		});

		$('.js-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			if(nextSlide === 0) {
				setTimeout(() => {
					slideFirst.play();
					slideSecond.stop();
					slideThird.stop();
				}, 1000);
			}else if(nextSlide === 1) {
				setTimeout(() => {
					slideSecond.play();
					slideFirst.stop();
					slideThird.stop();
				}, 1000);
			}else {
				setTimeout(() => {
					slideThird.play();
					slideFirst.stop();
					slideSecond.stop();
				}, 1000);
			}
		});
	},

	/** @description Set and run gallery slider. */
	initSliderMain: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			fade: true,
			cssEase: 'ease-out',
			autoplay: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			arrows: true,
			focusOnSelect: false,
			pauseOnHover: false,
			pauseOnFocus: false,
			prevArrow: Sliders.$domSliderPrev,
			nextArrow: Sliders.$domSliderNext,
			dots: true,
			appendDots: $('.js-slider-carousel-indicators'),
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 1
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		setTimeout(() => {
			this.$domSlider.addClass('slider-visible');
			this.runSlider(this.$domSlider, config);
		}, 3000);
	},

	initSliderTime: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: false,
			autoplay: true,
			autoplaySpeed: 1000,
			arrows: false,
			variableWidth: true,
			centerMode: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			swipeToSlide: true,
			touchThreshold: 200,
			focusOnSelect: false,
			pauseOnHover: false,
			pauseOnFocus: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3,
						variableWidth: true,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						variableWidth: true,
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderTime, config);
	},

	initSliderFull: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			variableWidth: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			swipeToSlide: true,
			touchThreshold: 200,
			arrows: true,
			prevArrow: Sliders.$domSliderFullPrev,
			nextArrow: Sliders.$domSliderFullNext,
			dots: true,
			appendDots: $('.js-slider-full-carousel-indicators'),
			responsive: [
				{
					breakpoint: 1600,
					settings: {
						variableWidth: false
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3,
						variableWidth: false
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						variableWidth: false
					}
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						variableWidth: false
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderFull, config);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
